export const dateTimeFormat = {
  defaultDate: 'DD-MM-YYYY',
  defaultDateTime: 'DD-MM-YYYY hh:mm'
}
